import Lottie from 'lottie-react';
import heroDesktop from './assets/lottie/heroDesktop.json';
import heroMobile from './assets/lottie/heroMobile.json';
import mascot from './assets/hq/mascot.svg';
import bg1 from './assets/hq/bg1.png';
import YC from './assets/hq/YC.svg';
import appStore from './assets/hq/appStore.svg';
import playStore from './assets/hq/playStore.svg';
import web from './assets/hq/webApp.svg';
import extension from './assets/hq/chrome.svg';
import wallet from './assets/hq/wallet.png';
import metakovan from './assets/hq/metakovan.svg';
import samsung from './assets/hq/samsungNext.svg';
import YCbw from './assets/hq/YCbw.svg';
import rebel from './assets/hq/rebelFund.svg';
import goodWater from './assets/hq/goodWater.svg';
import picusCapital from './assets/hq/picusCapital.svg';
import prasanna from './assets/hq/prasanna.svg';
import balaji from './assets/hq/balaji.svg';
import tribe from './assets/hq/tribe.svg';
import oraneDao from './assets/hq/orangeDao.svg';
import ethereumIcon from './assets/hq/ethereumIcon.svg';
import polygonIcon from './assets/hq/polygonIcon.svg';
import tronIcon from './assets/hq/tronIcon.svg';
import stargazeIcon from './assets/hq/stargazeIcon.svg';
import osmosisIcon from './assets/hq/osmosisIcon.svg';
import junoIcon from './assets/hq/junoIcon.svg';
import cypherCard from './assets/hq/cypherCard.png';
import multiChain from './assets/hq/multiChain.png';
import chainsWeb from './assets/hq/chainsWeb.svg';
import buyCrypto from './assets/hq/buyCrypto.png';
import buyCryptoMobile from './assets/hq/buyCryptoMobile.png';
import support24 from './assets/hq/support24.7.png';
import pos from './assets/hq/posMachine.png';
import locker from './assets/hq/locker.png';
import wireTransfer from './assets/hq/wireTransfer.png';
import spendControl from './assets/hq/spendControl.png';
import userManagement from './assets/hq/userManagement.png';
import userManagementMobile from './assets/hq/userManagementMobile.png';
import reimbursements from './assets/hq/reimbursements.png';
import offramp from './assets/hq/offRamp.png';
import downloadAppStore from './assets/hq/downloadAppStore.svg';
import downloadPlayStore from './assets/hq/downloadPlayStore.svg';
import tryWebApp from './assets/hq/tryWebApp.svg';
import addChromeExtension from './assets/hq/addChromeExtension.svg';
import takadoa from './assets/hq/takadao.svg';
import benqi from './assets/hq/benQI.svg';
import tegro from './assets/hq/tegro.svg';
import deltaPrime from './assets/hq/deltaPrime.svg';
import shardeum from './assets/hq/shardeum.svg';
import bandit from './assets/hq/bandit.svg';
import weavedb from './assets/hq/weaveDB.svg';
import gmx from './assets/hq/gmx.svg';
import zeroXppl from './assets/hq/zeroXppl.svg';
import xero from './assets/hq/xero.svg';
import quickbook from './assets/hq/quickbook.svg';
import businessCard from './assets/hq/businessCard.svg';
import walletMobile from './assets/hq/walletMobile.png';
import realWorldSpending from './assets/hq/realWorldSpending.svg';
import loadCardMobile from './assets/hq/loadCardMobile.svg';
import multichainMobile from './assets/hq/multichainMobile.png';
import selfCustodyMobile from './assets/hq/selfCustodyMobile.png';
import trueOwnerMobile from './assets/hq/trueOwnerMobile.png';
import installMobile from './assets/hq/installMobile.svg';
import businessCardMobile from './assets/hq/businessCardMobile.svg';
import wireTransferMobile from './assets/hq/wireTransferMobile.png';
import reimbursementsMobile from './assets/hq/reimbursementsMobile.png';
import spendControlMobile from './assets/hq/spendControlMobile.svg';
import offRampMobile from './assets/hq/offRampMobile.png';
import accountingMobile from './assets/hq/accountingMobile.svg';
import appStoreMobile from './assets/hq/appStoreMobile.svg';
import playStoreMobile from './assets/hq/playStoreMobile.svg';
import dappMobile from './assets/hq/dappMobile.png';
import extesionMobile from './assets/hq/extesionMobile.png';
import dappTextMobile from './assets/hq/dappTextMobile.svg';
import extensionTextMobile from './assets/hq/extensionTextMobile.svg';
import { useNavigate } from 'react-router-dom';
import { RouteNames } from './constants/routeNames';
import { RedirectURLs } from './constants/redirectURLS';
import { redirect, logAnalytics } from './util';
import FamewallEmbed from 'react-famewall';
import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import SeoComponent from './components/seoComponent';

export default function CypherHQ() {
  const navigate = useNavigate();
  const walletRef = useRef(null);

  const redirectUser = () => {
    if (navigator.userAgent.indexOf('Android') !== -1) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.cypherd.androidwallet';
    } else if (navigator.userAgent.indexOf('like Mac') !== -1) {
      window.location.href =
        'https://apps.apple.com/in/app/cypherd-wallet/id1604120414';
    } else {
      window.location.href = 'https://cypherd.io/';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoComponent page={window.location.pathname} />
      <div className='text-black overflow-hidden mb-[30px] lg:mb-[172px] font-manrope'>
        <div className='relative '>
          <div
            className='hidden lg:block w-[1px] h-full absolute top-0 left-[7%] -z-10'
            style={{
              background:
                'linear-gradient(180deg, rgba(167, 167, 167, 0.16) 0%, #E8E8E8 24.5%, #EDEDED 62%, #DADADA 100%)',
            }}
          />
          <div
            className='hidden lg:block w-[1px] h-full absolute top-0 right-[7%] -z-10'
            style={{
              background:
                'linear-gradient(180deg, rgba(182, 182, 182, 0.28) 0%, #E8E8E8 24.5%, #EDEDED 62%, #DADADA 100%)',
            }}
          />
          <div className='relative '>
            <div
              className='lg:hidden w-[1px] h-full absolute top-0 left-[7%] -z-10'
              style={{
                background:
                  'linear-gradient(180deg, rgba(167, 167, 167, 0.16) 0%, #E8E8E8 24.5%, #EDEDED 62%, #DADADA 100%)',
              }}
            />
            <div
              className='lg:hidden w-[1px] h-full absolute top-0 right-[7%] -z-10'
              style={{
                background:
                  'linear-gradient(180deg, rgba(182, 182, 182, 0.28) 0%, #E8E8E8 24.5%, #EDEDED 62%, #DADADA 100%)',
              }}
            />
            <img
              src={bg1}
              alt=''
              className='absolute top-0 left-1/2 transform -translate-x-1/2 -z-10 object-cover'
            />
            <div className='relative'>
              <div
                className='invisible lg:visible w-[1px] h-full absolute top-0 left-[16%] -z-10'
                style={{
                  background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(206, 206, 206, 0.75) 21.5%, #E6E6E6 46.5%)',
                }}
              />
              <div
                className='invisible lg:visible w-[1px] h-full absolute top-0 right-[16%] -z-10'
                style={{
                  background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, #DCDCDC 60%)',
                }}
              />
              <div className='pt-5'></div>

              {/* <div
              className='hidden bg-white rounded-full px-4 py-2 lg:flex items-center justify-center space-x-2 max-w-max mx-auto lg:mt-[140px] cursor-pointer'
              onClick={() => {
                redirect(
                  'https://twitter.com/CypherWalletIO/status/1777926509396643928'
                );
              }}
            >
              <p className='text-sm font-normal'>
                {'🎉 Meet us at Token 2049 '}
              </p>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='21'
                height='20'
                viewBox='0 0 21 20'
                fill='none'
              >
                <path
                  d='M8.69995 13.5999L12.3 9.9999L8.69995 6.3999'
                  stroke='#737B7D'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </div> */}
              <div className='hidden lg:block relative w-3/5 mx-auto mt-4 lg:z-0 lg:mt-[140px]'>
                <Lottie
                  animationData={heroDesktop}
                  loop={true}
                  width={320}
                  height={140}
                />
              </div>
              <div className='lg:hidden w-full h-full px-6 mt-[92px] relative -z-10'>
                <Lottie
                  animationData={heroMobile}
                  loop={true}
                  width={320}
                  height={140}
                />
              </div>
              <div className='w-[82%] lg:w-full mx-auto'>
                <p className='text-[#7F7F7F] text-[12px] font-normal mt-2 text-left mx-auto lg:text-base lg:mt-4 lg:max-w-[35%] lg:text-center'>
                  {
                    'Dive into the next evolution of banking with Cypher, the ultimate Web3 banking gateway designed for the digital age'
                  }
                </p>
                <div className='my-2 lg:my-4 flex space-x-1.5 justify-start lg:justify-center'>
                  <p className='font-medium text-[12px] lg:text-base'>
                    {'Backed by'}
                  </p>
                  <img src={YC} alt='' />
                </div>
              </div>
              <div className='hidden mt-6 lg:flex items-center justify-center space-x-3'>
                {[
                  {
                    img: appStore,
                    title: 'App Store',
                    url: RedirectURLs.appStore,
                  },
                  {
                    img: playStore,
                    title: 'Play Store',
                    url: RedirectURLs.playStore,
                  },
                  { img: web, title: 'DApp', url: RedirectURLs.dApp },
                  {
                    img: extension,
                    title: 'Chrome Extension',
                    url: RedirectURLs.extension,
                  },
                  {
                    img: mascot,
                    title: 'Cypher Business',
                    url: RedirectURLs.business,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className='rounded-full py-[6px] px-[12px] border border-[#B9B9B9] flex space-x-0.5 items-center justify-center max-w-max cursor-pointer'
                    onClick={() => {
                      if (item.title === 'Cypher Business') {
                        navigate('/business');
                      } else {
                        redirect(item.url);
                      }
                      logAnalytics({
                        category: 'cypherhq home',
                        action: 'click ' + item.title,
                        label: item.title,
                      });
                    }}
                  >
                    <img alt='' src={item.img} className='w-[30px] h-[30px]' />
                    <p className='font-semibold text-sm'>{item.title}</p>
                  </div>
                ))}
              </div>
              <div
                className='lg:hidden w-[82%] ml-[8%] '
                onClick={redirectUser}
              >
                <img src={installMobile} alt='' />
              </div>
              <div className='relative'>
                <div className='w-full h-[0.5px] bg-[#D9D9D999] lg:bg-[#ABABAB] mt-5 lg:mt-10' />
                <div className='lg:hidden absolute w-full h-[0.5px] bg-[#D9D9D999] lg:bg-[#ABABAB] top-[47px]' />
              </div>
              <img
                src={wallet}
                alt=''
                className='hidden lg:block mx-auto mt-3 w-[80%]'
              />
              <img
                src={walletMobile}
                alt=''
                className='lg:hidden mx-auto mt-3'
              />
              <img src={realWorldSpending} alt='' className='lg:hidden' />
              <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB] mt-10' />
              <div className='w-full h-[0.5px] bg-[#D9D9D9] lg:bg-[#ABABAB] mt-[44px] lg:mt-[110px]' />
            </div>

            <div className='hidden w-[86%] lg:grid grid-cols-5 mx-auto'>
              <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                <img src={metakovan} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                <img src={samsung} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                <img src={YCbw} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                <img src={rebel} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                <img src={goodWater} alt='' />
              </div>
            </div>

            <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
            <div className='hidden lg:block my-[55px]'>
              <p className='text-center font-semibold text-[36px]'>
                {'Backed by'}
              </p>
              <p className='text-center text-[#AEAEAE] font-normal text-[44px]'>
                {'Industry Leaders'}
              </p>
            </div>
            <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
            <div className='hidden w-[86%] lg:grid grid-cols-5 mx-auto'>
              <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                <img src={picusCapital} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                <img src={prasanna} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                <img src={balaji} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                <img src={tribe} alt='' />
              </div>
              <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                <img src={oraneDao} alt='' />
              </div>
            </div>
            <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />

            <div className='lg:hidden grid grid-cols-3 w-[86%] mx-auto'>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={metakovan} alt='' />
              </div>
              <div className='flex items-center justify-center h-[55px] border-x border-x-[#D9D9D9] '>
                <img src={YCbw} alt='' />
              </div>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={goodWater} alt='' />
              </div>
            </div>
            <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />
            <div className='lg:hidden grid grid-cols-4 w-[86%] mx-auto'>
              <div className=' col-span-1'>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-b border-r-[#D9D9D9] border-b-[#D9D9D9]'>
                  {<img src={samsung} alt='' />}
                </div>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-r-[#D9D9D9]'>
                  <img src={oraneDao} alt='' />
                </div>
              </div>
              <div className='col-span-2 flex flex-col items-center justify-center px-[6px]'>
                <p className='text-[20px] font-semibold'>{'Backed by'}</p>
                <p className='text-[20px] font-normal text-[#AEAEAE]'>
                  {'Industry Leaders'}
                </p>
              </div>

              <div className=' col-span-1'>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-l border-b border-l-[#D9D9D9] border-b-[#D9D9D9]'>
                  <img src={rebel} alt='' />
                </div>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-l  border-l-[#D9D9D9]'>
                  <img src={tribe} alt='' />
                </div>
              </div>
            </div>
            <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />
            <div className='lg:hidden grid grid-cols-3 w-[86%] mx-auto'>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={metakovan} alt='' />
              </div>
              <div className='flex items-center justify-center h-[55px] border-x border-x-[#D9D9D9] '>
                <img src={YCbw} alt='' />
              </div>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={goodWater} alt='' />
              </div>
            </div>
            <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />

            <div
              className='border mt-[77px] lg:mt-[150px]'
              style={{
                background:
                  'linear-gradient(90deg, #F8F8F8 0%, #ABABAB 9%, #F8F8F8 28.86%, #AAAAAA 100%)',
              }}
            />
          </div>

          <div className='my-8 w-[75%] mx-auto flex items-center justify-start lg:justify-between'>
            <p className='text-[24px] lg:text-[40px] font-semibold'>
              {'Cypher Wallet'}
            </p>
            <div className='hidden lg:flex items-center justify-center space-x-3'>
              {[
                {
                  img: appStore,
                  title: 'App Store',
                  url: RedirectURLs.appStore,
                },
                {
                  img: playStore,
                  title: 'Play Store',
                  url: RedirectURLs.playStore,
                },
                { img: web, title: 'DApp', url: RedirectURLs.dApp },
                {
                  img: extension,
                  title: 'Chrome Extension',
                  url: RedirectURLs.extension,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className='rounded-full py-[6px] px-[12px] border border-black flex space-x-1 items-center justify-center max-w-max cursor-pointer'
                  style={{
                    background:
                      'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)',
                    boxShadow: '0px 1px 4px 0px #00000029',
                  }}
                  onClick={() => {
                    redirect(item.url);
                    logAnalytics({
                      category: 'cypherhq home',
                      action: 'click ' + item.title,
                      label: item.title,
                    });
                  }}
                >
                  <img alt='' src={item.img} />
                  <p className='font-semibold text-sm'>{item.title}</p>
                </div>
              ))}
            </div>
          </div>

          <div
            className='border'
            style={{
              background:
                'linear-gradient(90deg, #F8F8F8 0%, #ABABAB 9%, #F8F8F8 28.86%, #AAAAAA 100%)',
            }}
          />

          <div className='' ref={walletRef} />

          <div className='mt-[60px] lg:mt-[150px]'>
            <p
              className='font-bold text-[28px] lg:text-[54px] text-left lg:text-center w-[86%] lg:w-full mx-auto'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Your All in One noncustodial wallet
            </p>
            <p
              className='font-normal text-[18px] lg:text-[44px] text-left lg:text-center w-[86%] lg:w-full mx-auto'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Your gateway for crypto universe
            </p>
            <div className='relative mt-4 mx-auto lg:w-1/4 mb-[18px] lg:mb-[120px] w-[86%] '>
              <p className='text-[#7F7F7F] text-[12px] lg:text-base font-normal text-left lg:text-center'>
                {
                  'Manage and stake crypto across 18+ Ethereum, esp tron & Cosmos blockchains'
                }
              </p>
              <img
                src={ethereumIcon}
                alt=''
                className='hidden lg:block opacity-50 top-0 -left-10 absolute'
              />
              <img
                src={polygonIcon}
                alt=''
                className='hidden lg:block opacity-50 -bottom-12 left-16 absolute'
              />
              <img
                src={tronIcon}
                alt=''
                className='hidden lg:block opacity-50 -bottom-10 left-1/2 -translate-x-1/2 absolute'
              />
              <img
                src={stargazeIcon}
                alt=''
                className='hidden lg:block opacity-50 -bottom-16 left-[70%] -translate-x-1/2 absolute'
              />
              <img
                src={osmosisIcon}
                alt=''
                className='hidden lg:block opacity-50 -bottom-6 -right-[7%] -translate-x-1/2 absolute'
              />
              <img
                src={junoIcon}
                alt=''
                className='hidden lg:block opacity-50 -top-6 -right-[10%] -translate-x-1/2 absolute'
              />
            </div>

            <div
              className={clsx(
                'lg:hidden ml-[8%] mb-[70px] lg:mb-[115px] relative',
                {
                  'w-[82%]': window.innerWidth < 640,
                  'w-[43%]': window.innerWidth >= 640,
                }
              )}
              onClick={redirectUser}
            >
              <img src={installMobile} alt='' className='max-w-max' />
              <img
                src={ethereumIcon}
                alt=''
                className='lg:hidden opacity-50 left-2 -bottom-8 absolute w-6 h-6'
              />
              <img
                src={polygonIcon}
                alt=''
                className='lg:hidden opacity-50 -bottom-12 left-12 absolute w-6 h-6'
              />
              <img
                src={tronIcon}
                alt=''
                className='lg:hidden opacity-50 -bottom-8 left-[50%] -translate-x-1/2 absolute w-6 h-6'
              />
              <img
                src={stargazeIcon}
                alt=''
                className='lg:hidden opacity-50 -bottom-8 right-[25%] absolute w-6 h-6'
              />
              <img
                src={osmosisIcon}
                alt=''
                className='lg:hidden opacity-50 bottom-0 right-[10%] -translate-x-1/2 absolute w-6 h-6'
              />
              <img
                src={junoIcon}
                alt=''
                className='lg:hidden opacity-50 bottom-6 right-[20%] -translate-x-1/2 absolute w-6 h-6'
              />
            </div>
          </div>

          <div className='hidden lg:grid grid-cols-2 items-center w-[65%] mx-auto gap-x-6 max-w-[1100px]'>
            <div className='border rounded-[20px] bg-[#F8F8F8] grid grid-rows-1 pb-8 h-[540px] w-[520px]'>
              <img src={cypherCard} alt='' className='mx-auto' />
              <div className='px-10 space-y-3.5'>
                <p className='text-[32px] font-semibold'>{'Cypher Card'}</p>
                <p className='text-[16px] font-normal'>
                  {'Enjoy the flexibility of virtual and physical Cypher cards'}
                </p>
                <div
                  className='bg-[#F7C645] px-8 py-2 max-w-max rounded-full cursor-pointer'
                  onClick={() => navigate(RouteNames.card + '#signup')}
                >
                  {'Get Cypher card'}
                </div>
                <div className='flex space-x-1 items-center'>
                  <p
                    className='text-[16px] font-bold cursor-pointer'
                    onClick={() => {
                      redirect(RedirectURLs.dApp);
                    }}
                  >
                    {'I have invite code'}
                  </p>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='19'
                    viewBox='0 0 20 19'
                    fill='none'
                  >
                    <path
                      d='M12.8157 8.4886L6.10301 15.2013L5 14.0983L11.7127 7.38558H5.79619V5.82568H14.3756V14.4051H12.8157V8.4886Z'
                      fill='black'
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className='grid grid-rows-2 gap-y-6 h-full'>
              <div className='border rounded-[20px] bg-[#F8F8F8] h-[256px] w-[521px]'>
                <img src={multiChain} alt='' className='w-full' />
              </div>
              <div className='border rounded-[20px] bg-[#FCECBF] grid grid-cols-2 h-[256px] w-[521px] '>
                <p className='text-[20px] font-semibold flex items-center justify-center text-center pl-5 pr-2 w-[90%]'>
                  {
                    'Load your card with over 500+ supported tokens across 18+ EVM & Cosmos chains.'
                  }
                </p>
                <img src={chainsWeb} alt='' className='w-full' />
              </div>
            </div>
          </div>

          <div className='hidden lg:grid grid-cols-[3fr_8fr_3fr] w-[65%] mx-auto gap-x-6 mt-6 max-w-[1100px]'>
            <div className='grid grid-rows-2 gap-y-6'>
              <div className='bg-[#FCECBF] rounded-[20px] font-bold text-[23px] p-6 text-center flex items-center max-w-[227px] max-h-[183px]'>
                {'Manage your card at any time for added security.'}
              </div>
              <img
                className='rounded-[20px] w-full h-full max-w-[227px] max-h-[183px] '
                src={buyCrypto}
                alt=''
              />
            </div>
            <div className='grid grid-cols-1 rounded-[20px] p-[30px] w-full bg-[#F8F8F8] '>
              <img src={pos} alt='' />
              <p className='mt-4 text-[27px] font-semibold'>
                {
                  'Utilize any self-custody wallet to instantly load cards and make seamless payments at over 40 million online and offline merchants worldwide.'
                }
              </p>
            </div>
            <div className='grid grid-rows-2 gap-y-6'>
              <img
                className='rounded-[20px] w-full h-full'
                src={support24}
                alt=''
              />
              <div className='bg-[#FCECBF] rounded-[20px] p-6 text-left relative'>
                <p className='font-bold text-[23px]'>
                  {'Be the true owner of your asserts'}
                </p>
                <img
                  className='absolute right-0 bottom-0'
                  alt=''
                  src={locker}
                />
              </div>
            </div>
          </div>

          <div className='lg:hidden mx-[8%]'>
            <div className='rounded-[20px] border-[2px] border-[#EBEBEB] max-w-[336px] relative mx-auto'>
              <img src={cypherCard} alt='' className='mx-auto' />
              <div className='absolute right-4 top-2 rounded-full blur-[32px] bg-[#ED4E33] opacity-40 w-[70px] h-[70px]' />
              <div className='absolute left-6 bottom-[80%] translate-y-1/2 rounded-full blur-[42px] bg-[#24E98A] opacity-50 w-[70px] h-[70px]' />
              <div className='absolute left-4 -bottom-1/8 translate-y-1/2 rounded-full blur-[42px] bg-[#8247E5] opacity-40 w-[80px] h-[80px] -z-10' />
              <p className='font-bold text-base pl-[16px] pr-[10px]'>
                {'Cypher Card'}
              </p>
              <p className='font-normal text-[12px] pl-[16px] pr-[10px] mt-[10px]'>
                {'Enjoy the flexibility of virtual and physical Cypher cards'}
              </p>
              <div
                className='mt-2 rounded-full px-[12px] py-[9px] max-w-max bg-[#F9D26C] ml-4 cursor-pointer z-10'
                onClick={() => navigate(RouteNames.card)}
              >
                <p
                  className='text-center font-bold text-[14px]'
                  onClick={() => navigate(RouteNames.card)}
                >
                  {'Get Cypher card'}
                </p>
              </div>
              <div className='mt-[9px] flex space-x-1 items-center ml-4 mb-[18px]'>
                <p
                  className='font-bold text-[14px] cursor-pointer'
                  onClick={() => {
                    redirect(RedirectURLs.dApp);
                  }}
                >
                  {'I have invite code'}
                </p>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='19'
                  height='19'
                  viewBox='0 0 19 19'
                  fill='none'
                  Know
                  More
                >
                  <path
                    d='M12.2659 8.66291L5.55321 15.3756L4.4502 14.2726L11.1629 7.5599H5.24638V6H13.8258V14.5795H12.2659V8.66291Z'
                    fill='black'
                  />
                </svg>
              </div>
            </div>

            <div className='flex space-x-[8px] justify-center mt-[12px]'>
              <div className='w-[162px] h-[180px]'>
                <img
                  src={multichainMobile}
                  alt=''
                  className='w-[162px] h-[180px]'
                />
              </div>
              <div className='rounded-[20px] bg-[#FCECBF] px-[12px] py-[36px] w-[162px] h-[180px]'>
                <p className='font-bold text-[19px] text-center'>
                  {'Manage your card at any time for added security.'}
                </p>
              </div>
            </div>

            <div className='mt-[12px]'>
              <img
                src={loadCardMobile}
                alt=''
                className='w-[336px] h-[230px] mx-auto'
              />
            </div>

            <div className='mt-[12px] flex justify-center space-x-[8px]'>
              <div className='w-[129px] h-[129px]'>
                <img src={buyCryptoMobile} alt='' className='w-full' />
              </div>
              <div className='rounded-[20px] bg-[#F5F5F5] px-[12px] py-[36px] h-[129px] w-[191px]'>
                <p className='font-bold text-[16px] text-center'>
                  {'24/7 Support: Our team is always here to help.'}
                </p>
              </div>
            </div>

            <div className='mt-[12px]'>
              <img
                src={selfCustodyMobile}
                alt=''
                className='w-[336px] h-[199px] mx-auto'
              />
            </div>

            <div className='mt-[12px]'>
              <img
                src={trueOwnerMobile}
                alt=''
                className='w-[336px] h-[96px] mx-auto'
              />
            </div>
          </div>

          <div
            className='hidden lg:block h-[1px] w-full mt-[150px]'
            style={{
              background:
                'linear-gradient(90deg, #F8F8F8 0%, #ABABAB 9%, #F8F8F8 28.86%, #AAAAAA 100%)',
            }}
          />

          <div className='lg:hidden relative border-y h-[19px] border-[#D9D9D999] mt-[30px]'>
            <div
              className='w-[1px] h-full absolute top-0 left-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
            <div
              className='w-[1px] h-full absolute top-0 right-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
          </div>

          <div className='w-[75%] py-6 lg:py-8 mx-auto flex justify-between items-center'>
            <p className='text-[24px] lg:text-[40px] font-semibold'>
              {'Cypher Business'}
            </p>
            <div className='hidden lg:block relative'>
              <div
                className='bg-[#F9D26C] font-bold text-base py-2 px-8 rounded-full cursor-pointer'
                onClick={() => {
                  navigate('/business');
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link to business static page',
                    label: 'get started with cypher business',
                  });
                }}
              >
                {'Get Started with Cypher Business '}
              </div>
              <div
                className='absolute top-0 -right-10 w-40 h-8 bg-[#F9D26C]'
                style={{
                  filter: 'blur(32px)',
                }}
              />
            </div>
          </div>
          <div
            className='hidden lg:block h-[1px] w-full'
            style={{
              background:
                'linear-gradient(90deg, #F8F8F8 0%, #ABABAB 9%, #F8F8F8 28.86%, #AAAAAA 100%)',
            }}
          />
          <div className='lg:hidden relative border-y h-[19px] border-[#D9D9D999]'>
            <div
              className='w-[1px] h-full absolute top-0 left-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
            <div
              className='w-[1px] h-full absolute top-0 right-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
          </div>

          <div className='mt-[70px] lg:mt-[150px] mx-[6%] lg:mx-auto'>
            <p
              className='font-bold text-[26px] text-left lg:text-[54px] lg:text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Financial operating system
            </p>
            <p
              className='font-normal text-[26px] text-left lg:text-[44px] lg:text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              For Web3 Teams
            </p>
            <p className='text-[#7F7F7F] font-normal text-[12px] lg:text-base text-left lg:text-center w-full lg:w-[35%] mx-auto mt-2 lg:mt-4'>
              Manage Card Spend & Pay Vendors, Contractors, and Employees
              Directly from Your Gnosis Safe or Ledger. Built for Web3 Teams &
              DAOs.
            </p>
          </div>

          <div className='hidden lg:block mt-[150px] w-[65%] mx-auto font-manrope space-y-[16px] max-w-[1100px]'>
            <div className='grid grid-cols-[8fr_4fr_4fr] gap-x-6 '>
              <div className='bg-[#F8F8F8] rounded-[20px] h-[540px]'>
                <img src={businessCard} alt='' className='mx-auto' />

                <p className='text-[32px] font-semibold mt-[36px] mx-[40px]'>
                  {'Cypher Corporate Card'}
                </p>
                <p className='text-[20px] font-normal mx-[40px] mt-[15px] mb-[52px]'>
                  {
                    'Easily issue multiple cards for your team and departments to simplify expense management.'
                  }
                </p>
              </div>
              <img src={wireTransfer} alt='' className='h-[544px] w-[274px]' />
              {/* <div className='rounded-[20px] p-[22px] bg-[#FCECBF] h-[540px]'>
              <p className='text-[23px] font-bold w-1/2 mb-[28px]'>
                {'Global Wire Transfers'}
              </p>
              <div className='space-y-[18px]'>
                <p className='text-[18px] font-bold'>{'Start in USDC,'}</p>
                <p className='text-[18px] font-bold'>
                  {'Pay your team or vendors in fiat'}
                </p>
                <p className='text-[18px] font-bold'>{'ACH transfers (US)'}</p>
                <p className='text-[18px] font-bold'>{'NEFT payments (INR)'}</p>
              </div>
              <div className='flex justify-end items-center'>
                <img
                  src={wireTransfer}
                  alt=''
                  // className='h-[200px]'
                />
              </div>
            </div> */}
              <div className='grid grid-rows-2 gap-y-6'>
                <img src={spendControl} alt='' className='h-[260px]' />
                <img src={userManagement} alt='' className='h-[260px]' />
              </div>
            </div>
            <div className='grid grid-cols-2 gap-x-6'>
              <div className='grid grid-rows-2 gap-y-4'>
                <div className='max-w-[521px] max-h-[256px]'>
                  <img src={reimbursements} alt='' className='w-full' />
                </div>
                <div className='bg-[#FCECBF] rounded-[20px] w-full px-5 max-h-[260px] max-w-[521px]'>
                  <div className='grid grid-cols-2 gap-x-12 mt-6'>
                    <div>
                      <p className='font-bold text-[24px]'>
                        {'Coming soon...'}
                      </p>
                      <p className='font-bold text-[24px] mt-2.5'>
                        {'Accounting Integration'}
                      </p>
                    </div>
                    <img src={quickbook} alt='' className='' />
                  </div>
                  <div className='flex justify-between items-start space-x-10'>
                    <p className='font-bold text-[18px] mt-2.5'>
                      {
                        'Sync blockchain/card spend with QuickBooks, Xero effortlessly.'
                      }
                    </p>

                    <img src={xero} alt='' className='h-[100px]' />
                  </div>
                </div>
              </div>
              <div className='bg-[#F8F8F8] rounded-[20px] px-[30px] max-w-[521px] max-h-[540px]'>
                <img src={offramp} alt='' className='mt-[78px] mx-auto' />
                <p className='font-semibold text-[32px] mt-[52px]'>
                  {'Stablecoin Off-Ramp'}
                </p>
                <p className='font-normal text-[20px] mt-[15px]'>
                  {
                    'You can instantly convert your USDC to USD before funding the corporate card or sending out wire transfers.'
                  }
                </p>
              </div>
            </div>
          </div>

          <div className='lg:hidden mt-[80px]'>
            <img
              src={businessCardMobile}
              alt=''
              className='w-[336px] h-[324px] mx-auto'
            />
            <img
              src={wireTransferMobile}
              alt=''
              className='w-[336px] h-[252px] mt-[12px] mx-auto'
            />
            <div className='flex space-x-[12px] mt-[12px] mx-auto justify-center items-center'>
              <img
                src={userManagementMobile}
                alt=''
                className='w-[132px] h-[129px]'
              />
              <img
                src={spendControlMobile}
                alt=''
                className='w-[192px] h-[129px]'
              />
            </div>
            <img
              src={reimbursementsMobile}
              alt=''
              className='w-[336px] h-[104px] mt-[12px] mx-auto'
            />
            <img
              src={offRampMobile}
              alt=''
              className='w-[336px] h-[212px] mt-[12px] mx-auto'
            />
            <img
              src={accountingMobile}
              alt=''
              className='w-[336px] h-[140px] mt-[12px] mx-auto'
            />
          </div>

          <div className='bg-[#2C2C2C] lg:rounded-[20px] px-[32px] lg:px-0 pt-[32px] lg:pt-[36px] pb-[28px] lg:pb-[19px] mt-[50px] lg:mt-[130px] w-full lg:w-[65%] lg:mx-auto'>
            <p
              className='font-bold text-[24px] lg:text-[32px] text-left lg:text-center w-[80%] lg:w-full'
              style={{
                background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
                backgroundClip: 'text,',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Get Started With The Financial Power House
            </p>
            <p
              className='font-normal text-[20px] lg:text-[34px] text-left lg:text-center'
              style={{
                background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
                backgroundClip: 'text,',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              For Web3 Teams
            </p>
            <div
              className='mt-[46px] rounded-full p-[14px] max-w-[390px] mx-auto relative z-10'
              style={{
                border: '1px solid #5C5C5C',
              }}
            >
              <div
                className='rounded-full bg-[#F7C645] px-[9px] py-[12px] font-bold text-base text-center cursor-pointer '
                onClick={() => {
                  navigate('/business');
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link to business static page',
                    label: 'get started',
                  });
                }}
              >
                {'Get Started'}
              </div>
              <div className='w-[93px] h-[65px] bg-[#F7B300] blur-[62px] absolute top-0 left-0' />
            </div>
          </div>

          <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB] mt-[150px]' />
          <div className='hidden w-[86%] lg:grid grid-cols-5 mx-auto'>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={takadoa} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={benqi} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC] space-x-2'>
              <img src={tegro} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={deltaPrime} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={shardeum} alt='' />
            </div>
          </div>

          <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />

          <div className='hidden lg:block my-[55px]'>
            <p className='text-center font-semibold text-[36px]'>
              {'Our Valued Customers'}
            </p>
            <p className='text-center text-[#AEAEAE] font-normal text-[32px]'>
              {'Who are impressed by our product'}
            </p>
          </div>
          <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
          <div className=' hidden w-[86%] lg:grid grid-cols-6 mx-auto'>
            <div />
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={bandit} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={weavedb} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={gmx} alt='' />
            </div>
            <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
              <img src={zeroXppl} alt='' />
            </div>
            <div />
          </div>
          <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />

          <div className='lg:hidden relative border-t border-[#D9D9D999] mt-[32px]'>
            <div
              className='w-[1px] h-full absolute top-0 left-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
            <div
              className='w-[1px] h-full absolute top-0 right-[7%] -z-10'
              style={{
                background: '#E8E8E8',
              }}
            />
            <div
              className='w-full h-[0.5px] mt-[40px]'
              style={{
                background: '#D9D9D9',
              }}
            />

            <div
              className='w-full h-[0.5px] mt-[87px]'
              style={{
                background: '#D9D9D9',
              }}
            />

            <div className='grid grid-cols-3 w-[86%] mx-auto'>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={takadoa} alt='' className='w-[68px]' />
              </div>
              <div className='flex items-center justify-center h-[55px] border-x border-x-[#D9D9D9] '>
                <img src={weavedb} alt='' className='w-[73px]' />
              </div>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={shardeum} alt='' className='w-[85px]' />
              </div>
            </div>
            <div className='w-full h-[0.5px] bg-[#D9D9D9] ' />
            <div className='grid grid-cols-4 w-[86%] mx-auto'>
              <div className=' col-span-1'>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-b border-r-[#D9D9D9] border-b-[#D9D9D9]'>
                  {
                    <img
                      src={deltaPrime}
                      alt=''
                      className='w-[50px] h-[40px]'
                    />
                  }
                </div>
                <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-r-[#D9D9D9]'>
                  <img src={zeroXppl} alt='' className='w-[32px] h-[32px]' />
                </div>
              </div>
              <div className='col-span-2 flex flex-col items-center justify-center px-[6px]'>
                <p className='text-[20px] font-semibold text-center'>
                  {'Our Valued Customers'}
                </p>
                <p className='text-[16px] font-normal text-[#AEAEAE] text-center'>
                  {'Who are impressed by our product'}
                </p>
              </div>

              <div className='col-span-1'>
                <div className='flex items-center justify-center h-[80px] w-full border-l border-b border-l-[#D9D9D9] border-b-[#D9D9D9]'>
                  <img src={gmx} alt='' className='w-[65px]' />
                </div>
                <div className='flex items-center justify-center h-[80px] w-full border-l  border-l-[#D9D9D9]'>
                  <img src={benqi} alt='' className='w-[50px]' />
                </div>
              </div>
            </div>
            <div className='w-full h-[0.5px] bg-[#D9D9D9] ' />
            <div className='grid grid-cols-2 w-[86%] mx-auto'>
              <div className='flex items-center justify-center h-[55px]'>
                <img src={bandit} alt='' className='w-[88px] opacity-45' />
              </div>
              <div className='flex items-center justify-center h-[55px] border-x border-x-[#D9D9D9] '>
                <img src={tegro} alt='' className='w-[68px]' />
              </div>
            </div>
            <div className='w-full h-[0.5px] bg-[#D9D9D9] ' />
            <div className='w-full h-[0.5px] bg-[#D9D9D9] mt-[124px] ' />
          </div>

          <div id='downloadCypherWallet'></div>
          <div className='hidden lg:block mt-[150px] '>
            <p
              className='font-bold text-[54px] text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Download
            </p>
            <p
              className='font-normal text-[44px] text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Experience Cypher Wallet
            </p>
            <p className='text-[#7F7F7F] font-normal text-base text-center w-[35%] mx-auto mt-4'>
              Manage and stake crypto across 18+ Ethereum & Cosmos blockchains
            </p>
          </div>

          <div className='lg:hidden mt-[32px] w-[86%] ml-[7%]'>
            <p
              className='font-bold text-[26px] text-left'
              style={{
                background:
                  'linear-gradient(180deg, #000 46.05%, #959595 99.46%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Download & Experience
            </p>
            <p
              className='font-normal text-[26px] text-left'
              style={{
                background:
                  'linear-gradient(180deg, #000 46.05%, #959595 99.46%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Cypher Wallet
            </p>
            <p className='text-[#7F7F7F] font-normal text-[12px] text-left w-full mx-auto mt-2'>
              Manage or stake crypto across 18+ Ethereum & Cosmos blockchains
            </p>

            <div className='mt-6' onClick={redirectUser}>
              <img src={installMobile} alt='' />
            </div>
          </div>
          <div className='hidden lg:block mt-[100px]'>
            <div className='grid grid-cols-2 grid-rows-2  gap-4 w-[65%] max-w-[1100px] mx-auto'>
              <img
                src={downloadAppStore}
                alt=''
                className='cursor-pointer'
                onClick={() => {
                  redirect(RedirectURLs.appStore);
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link to app store',
                    label: 'link to app store',
                  });
                }}
              />
              <img
                src={downloadPlayStore}
                alt=''
                className='cursor-pointer'
                onClick={() => {
                  redirect(RedirectURLs.playStore);
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link to play store',
                    label: 'link to play store',
                  });
                }}
              />
              <img
                src={tryWebApp}
                alt=''
                className='cursor-pointer'
                onClick={() => {
                  redirect(RedirectURLs.dApp);
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link to dapp',
                    label: 'link to dapp',
                  });
                }}
              />
              <img
                src={addChromeExtension}
                alt=''
                className='cursor-pointer'
                onClick={() => {
                  redirect(RedirectURLs.extension);
                  logAnalytics({
                    category: 'cypherhq home',
                    action: 'click link chrome webstore',
                    label: 'link chrome webstore',
                  });
                }}
              />
            </div>
          </div>

          <div className='lg:hidden mt-[24px] w-[86%] mx-auto'>
            <p className='font-normal text-[12px] text-[#7F7F7F]'>
              {'Also Available on'}
            </p>
            <div className='grid grid-cols-2 mt-[12px] space-x-[12px]'>
              <img src={appStoreMobile} alt='' className='w-full' />
              <img src={playStoreMobile} alt='' className='w-full' />
            </div>
            <div className='my-4 rounded-[12px] border border-[#D2D2D2] bg-[#FDF7E5] pt-[24px] px-[24px]'>
              <div className='flex justify-between items-center'>
                <img src={dappTextMobile} alt='' />
                <div
                  className='rounded-full bg-[#F9D26C] px-[8px] py-[6px] text-center font-medium text-[12px]'
                  onClick={() => redirect(RedirectURLs.dApp)}
                >
                  {'Know More'}
                </div>
              </div>
              <img src={dappMobile} alt='' className='w-full' />
            </div>
            <div className='rounded-[12px] border border-[#D2D2D2] bg-[#FDF7E5] pt-[24px] px-[24px]'>
              <div className='flex justify-between items-center'>
                <img src={extensionTextMobile} alt='' />
                <div
                  className='rounded-full bg-[#F9D26C] px-[8px] py-[6px] text-center font-medium text-[12px]'
                  onClick={() => redirect(RedirectURLs.extension)}
                >
                  {'Know More'}
                </div>
              </div>
              <img src={extesionMobile} alt='' className='w-full mt-[16px]' />
            </div>
          </div>

          <div className='mt-[80px] lg:mt-[120px] mb-[24px] lg:mb-[103px] w-[86%] ml-[7%] lg:ml-0 lg:w-full'>
            <p
              className='font-bold text-[26px] lg:text-[54px] text-left lg:text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Global Love for Cypher
            </p>
            <p
              className='font-normal text-[24px] lg:text-[44px] text-left lg:text-center'
              style={{
                background: 'linear-gradient(180deg, #000000 0%, #959595 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              See What Our Community Says
            </p>
          </div>

          <div className='hidden lg:block bg-[#1F1F1F] h-[1px] w-full' />
          <div className='hidden lg:block bg-[#1F1F1F] h-[1px] w-full mt-[120px]' />

          <div className='w-[86%] mx-auto '>
            <div className='max-h-[600px] overflow-y-scroll'>
              <FamewallEmbed wallUrl='cypherhq' />
            </div>
          </div>
          <div className='hidden lg:block bg-[#1F1F1F] h-[1px] w-full' />
          <div className='hidden lg:block bg-[#1F1F1F] h-[1px] w-full mt-[100px]' />

          <div
            className={
              'hidden lg:block mt-[87px] mb-[120px] bg-[#2C2C2C] py-[64px] px-[52px] mx-auto w-[65%] rounded-[20px]'
            }
          >
            <p
              className='font-semibold text-[32px] text-center'
              style={{
                background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {'Enjoy the freedom of spending your crypto anytime, '}
            </p>
            <p
              className='font-normal text-[34px] text-center'
              style={{
                background: 'linear-gradient(180deg, #FFF 0%, #6D6D6D 99%)',
                webkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {'anywhere in the world, with Cypher'}
            </p>
            <div className='flex items-center justify-center space-x-3 mt-[68px]'>
              {[
                {
                  img: appStore,
                  title: 'App Store',
                  color: '#2FB7EE',
                  url: RedirectURLs.appStore,
                },
                {
                  img: playStore,
                  title: 'Play Store',
                  color: '#62E4A8',
                  url: RedirectURLs.playStore,
                },
                {
                  img: web,
                  title: 'DApp',
                  color:
                    'linear-gradient(0deg, #FFCA48 0%, #FFCA48 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
                  url: RedirectURLs.dApp,
                },
                {
                  img: extension,
                  title: 'Chrome Extension',
                  color:
                    'linear-gradient(0deg, #F44336 0%, #F44336 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
                  url: RedirectURLs.extension,
                },
                {
                  img: mascot,
                  title: 'Cypher Business',
                  color:
                    'linear-gradient(0deg, #FFCA48 0%, #FFCA48 100%), linear-gradient(0deg, #F44336 0%, #F44336 100%)',
                  url: RedirectURLs.business,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className='rounded-full py-[6px] px-[12px] border border-[#000] flex space-x-1 items-center justify-center max-w-max relative cursor-pointer'
                  style={{
                    background:
                      'linear-gradient(180deg, #5D5D5D 0%, #393939 100%)',
                  }}
                  onClick={() => {
                    if (item.title === 'Cypher Business') {
                      navigate('/business');
                    } else {
                      redirect(item.url);
                    }
                  }}
                >
                  <img alt='' src={item.img} className='w-[30px] h-[30px]' />
                  <p className='font-semibold text-sm text-[#FFFFFF]'>
                    {item.title}
                  </p>
                  <div
                    className='absolute top-0 left-0 w-[54px] h-[38px] blur-[62px]'
                    style={{
                      background: item.color,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className='hidden lg:block bg-[#1F1F1F] h-[1px] w-full' />
        </div>
      </div>
    </>
  );
}
